import { useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { Form } from '@ui/components/Form';
import { ThemeButton } from '@ui/components/ThemeButton';

import { DescriptionInput } from '@features/club/ui/ClubNewsItemEditForm/DescriptionInput';
import { PromoInput } from '@features/club/ui/ClubNewsItemEditForm/PromoInput';
import { PublicationDateInput } from '@features/club/ui/ClubNewsItemEditForm/PublicationDateInput';
import { TitleInput } from '@features/club/ui/ClubNewsItemEditForm/TitleInput';
import { NewsPost } from '@features/shared/api/typings';

import styles from './ClubNewsItemEditForm.module.css';

type Props = {
  className?: string;
  initialValue?: NewsPost;
  onSubmit: (newsArticle: NewsPost) => void;
  onCancel?: () => void;
  disabled?: boolean;
};
export function ClubNewsItemEditForm({
  className,
  initialValue,
  onSubmit,
  onCancel,
  disabled,
}: Props) {
  const methods = useForm<NewsPost>({
    disabled,
    defaultValues: getDefaultValues(initialValue),
  });

  const handleSubmit = useCallback(() => {
    onSubmit(methods.getValues());
  }, [onSubmit, methods]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit}>
        <Form className={className}>
          <TitleInput />
          <PromoInput />
          <PublicationDateInput />
          <DescriptionInput />

          <div className={styles.buttonBar}>
            <ThemeButton inverted onClick={onCancel}>
              Отмена
            </ThemeButton>
            <ThemeButton onClick={handleSubmit}>Опубликовать</ThemeButton>
          </div>
        </Form>
      </form>
    </FormProvider>
  );
}

function getDefaultValues(newsArticle?: NewsPost): Partial<NewsPost> {
  return {
    id: newsArticle?.id,
    title: newsArticle?.title || '',
    promoted: newsArticle?.promoted || false,
    publishTimestampMs: newsArticle?.publishTimestampMs || new Date().getTime(),
    text: newsArticle?.text || '',
  };
}
